import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appShareData1: {
      share_url: "https://s1.mi.com/m/partner/2021/0113necel/",
      img_url: "https://s1.mi.com/m/partner/2021/0113necel/img/role2.jpg",
      title: "小米盲盒",
      content: "小米@你，开新年盲盒领隐藏惊喜。",
    },
    appShareData2: {
      share_url: "https://s1.mi.com/m/partner/2021/0113necel/",
      img_url: "https://s1.mi.com/m/partner/2021/0113necel/img/role2.jpg",
      title: "小米盲盒",
    },
    publicUrl: "https://s1.mi.com/m/partner/2021/0113necel"


  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
